<div class="calendar calendar-wrapper mt-3 d-block f-1 o-auto">
  <ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cell-top">
      <span class="cal-day-badge"
            *ngIf="!isClinicView && events && day['badgeTotal'] > 0">{{ day['badgeTotal'] }}</span>
      <span class="cal-day-number">{{ day['date'] | calendarDate: 'monthViewDayNumber':locale }}</span>
    </div>
    <div *ngIf="events" class="cell-totals">
      <div (click)="dayEventClicked.emit({value: group, event: $event})" *ngFor="let group of day['eventGroups']"
           class="badge badge-{{ group[0] }}" title="">
        <ng-container *ngTemplateOutlet="eventTmpl || defaultEventTmpl; context: {item: group}"></ng-container>
        <div class="bg_main_gray_02">
          <ng-template #defaultEventTmpl> {{ group[0] }}: {{ group[1].length }} Patients</ng-template>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #hourlyCovidVaccinationCountTemplate let-weekEvent="weekEvent">
    <div class="cal-event" style="line-height: 1.2em !important;">
      <div>Scheduled : {{weekEvent.event.meta.scheduled}}</div>
      <div>Vaccinated : {{weekEvent.event.meta.completed}}</div>
      <div>Capacity : {{weekEvent.event.meta.capacity}}</div>
    </div>
  </ng-template>
  <div
    class="calendar_header_container title-container d-flex align-items-center justify-content-between pl-3 pr-3 main_gray_09 mb-3">
    <div class="btn_container m-0 p-0 h-100 f-1">
      <div class="btn-group">
        <div class="calendar_button title fw-600 main_gray_07 align-items-center c-p"
             (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">
          Month
        </div>
        <div class="calendar_button title fw-600 main_gray_07 align-items-center c-p"
             (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">
          Week
        </div>
        <div class="calendar_button title fw-600 main_gray_07 align-items-center c-p"
             (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">
          Day
        </div>
        <div class="calendar_button title fw-600 main_gray_07 align-items-center c-p"
             [class.active]="view == 'Gannt'"
             (click)="setView('Gannt')">
          Gannt View
        </div>
      </div>
    </div>

    <div class="f-1 mr-5 ml-5 hide" *ngIf="isAdmin">
      <div class="wrap-mat-form-field mat-select-wrapper d-flex align-items-center">
        <label class="input_label mr-3 fs-14 nowrap">Select Clinic</label>
        <mat-form-field>
          <mat-label>Select Clinic</mat-label>

          <input
            (click)="resetSearchClinic()"
            [(ngModel)]="clinic"
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            matInput
            type="text"
          >
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="changeClinic()"
            [displayWith]="displayFn"
            autoActiveFirstOption
          >
            <mat-option *ngFor="let clinic of filteredClinicsList$ | async" [value]="clinic">
              {{clinic.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="arrow_container ml-5">
      <div class="leftArrowContainer">
        <i class="btn-act icon-back border-none btn-ic" mwlCalendarPreviousView [view]="view === 'Gannt' ? 'day' : view"
           [(viewDate)]="viewDate"
           (viewDateChange)="viewDateChange($event)"></i>
      </div>
      <div class="dateTitle font_size_md d-flex pl-3 pr-3 align-items-center" mwlCalendarToday [(viewDate)]="viewDate">
        {{ viewDate | calendarDate: (view === 'Gannt' ? 'day' : view) + 'ViewTitle':'en' }}
      </div>
      <div class="rightArrowContainer">
        <i class="btn-act icon-next border-none btn-ic" mwlCalendarNextView [view]="view === 'Gannt' ? 'day' : view"
           [(viewDate)]="viewDate"
           (viewDateChange)="viewDateChange($event)"></i>
      </div>
    </div>
  </div>

  <div [ngSwitch]="view" class="pl-3 pr-3">
    <mwl-calendar-month-view *ngSwitchCase="CalendarView['Month']" [viewDate]="viewDate" [events]="calendarEvents"
                             [activeDayIsOpen]="activeDayIsOpen" [cellTemplate]="customCellTemplate"
                             (dayClicked)="dayClicked.observers.length ? dayClicked.emit($event.day) : handleClickDay($event.day)"
                             (eventClicked)="handleClickEvent($event.event)"
                             (beforeViewRender)="beforeMonthViewRender($event)">
    </mwl-calendar-month-view>
    <mwl-calendar-week-view (eventClicked)="handleClickEvent($event.event)" *ngSwitchCase="CalendarView['Week']"
                            [viewDate]="viewDate" [events]="hourlyCovidVaccinationCount"
                            [eventTemplate]="hourlyCovidVaccinationCountTemplate"
                            (beforeViewRender)="beforeWeekViewRender($event)">
    </mwl-calendar-week-view>
    <mwl-calendar-day-view (eventClicked)="handleClickEvent($event.event)" *ngSwitchCase="CalendarView['Day']"
                           [events]="hourlyCovidVaccinationCount" [eventTemplate]="hourlyCovidVaccinationCountTemplate"
                           [viewDate]="viewDate"
                           (beforeViewRender)="beforeDayViewRender($event)">
    </mwl-calendar-day-view>
    <app-gannt-view *ngSwitchCase="'Gannt'"
                    [clinic]="clinic"
                    [date]="viewDate"
    ></app-gannt-view>
  </div>
  <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

</div>
